import * as React from "react";
import { Spinner } from "components/common";
import ExpandedSectionCount from "components/common/EntityDataTable/ExpandedSectionCount";
import { useForwarderInputMetricsFor } from "../ForwarderInputMetricsContext";
import { METRIC_COLUMN_IDS } from "../metricColumns";
const SECTION_NAME = METRIC_COLUMN_IDS.associatedStreams;
const AssociatedStreamsCell = ({ input }) => {
  const { metrics, isInitialLoading, isError } = useForwarderInputMetricsFor(input.input_id, input.forwarder_node_id);
  if (isInitialLoading && !metrics) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  if (isError || !(metrics == null ? void 0 : metrics.messages_per_stream)) {
    return /* @__PURE__ */ React.createElement("span", { "aria-label": `No associated streams available for input ${input.title}` }, "\u2014");
  }
  const streamCount = Object.keys(metrics.messages_per_stream).length;
  return /* @__PURE__ */ React.createElement(
    ExpandedSectionCount,
    {
      entityId: input.id,
      section: SECTION_NAME,
      count: streamCount,
      label: `associated streams for ${input.title}`
    }
  );
};
export default AssociatedStreamsCell;
